import React from "react";
import {
    Card,
    CardContent,
    CardActions,
    Stack,
    Typography,
    IconButton,
    Chip,
    Divider,
    Menu,
    MenuItem,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ModelMiniature from "./ModelMiniature";
import { resolveAuthorName } from "../../utils/modelPreview";

export default function ModelCard({
    model,
    onEdit,
    onDelete,
    onPreview,
    onCreateDesign,
    onRename,
}) {
    const [menuAnchor, setMenuAnchor] = React.useState(null);
    const author = resolveAuthorName(model.autor);
    const updatedAt = model.updatedAt || model.lastUpdate || model.createdAt;

    const openMenu = (event) => setMenuAnchor(event.currentTarget);
    const closeMenu = () => setMenuAnchor(null);

    const run = (fn) => {
        closeMenu();
        fn(model);
    };

    return (
        <Card variant="outlined" sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <CardContent sx={{ pb: 1, display: "flex", flexDirection: "column", gap: 1.25 }}>
                <ModelMiniature model={model} />

                <Stack spacing={0.5}>
                    <Typography variant="h6" noWrap title={model.title}>{model.title}</Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ minHeight: 40 }}>
                        {model.description || "Aucune description"}
                    </Typography>
                </Stack>

                <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
                    <Chip size="small" label={`Auteur: ${author}`} />
                    <Chip
                        size="small"
                        variant="outlined"
                        label={`Date: ${updatedAt ? new Date(updatedAt).toLocaleDateString() : "-"}`}
                    />
                </Stack>
            </CardContent>

            <Divider />

            <CardActions sx={{ p: 1.25, pt: 1, mt: "auto" }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ width: "100%" }}>
                    <Typography variant="caption" color="text.secondary">Options</Typography>
                    <IconButton size="small" onClick={openMenu}>
                        <MoreVertIcon fontSize="small" />
                    </IconButton>
                </Stack>

                <Menu
                    anchorEl={menuAnchor}
                    open={Boolean(menuAnchor)}
                    onClose={closeMenu}
                >
                    <MenuItem onClick={() => run(onPreview)}>Visualiser</MenuItem>
                    <MenuItem onClick={() => run(onEdit)}>Modifier</MenuItem>
                    <MenuItem onClick={() => run(onRename)}>Renommer</MenuItem>
                    <MenuItem onClick={() => run(onCreateDesign)}>Créer design</MenuItem>
                    <MenuItem onClick={() => run(onDelete)} sx={{ color: "error.main" }}>Supprimer</MenuItem>
                </Menu>
            </CardActions>
        </Card>
    );
}
